import React from 'react';

interface Props {
  children: React.ReactNode;
}

export default function Description({ children }: Props) {
  return <div className="text-12 text-grey600">{children}</div>;
}
